var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import padding from "../global/padding";
import { spacingCss } from "../global/css";
var addPadding = function (_a, spacing) {
    var large = _a.large, medium = _a.medium, small = _a.small, tiny = _a.tiny, flush = _a.flush;
    if (large) {
        return spacing.eight;
    }
    else if (medium) {
        return spacing.four;
    }
    else if (small) {
        return spacing.two;
    }
    else if (tiny) {
        return spacing.one;
    }
    else if (flush) {
        return 0;
    }
    return padding.base;
};
export default styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: block;\n  clear: both;\n  border-radius: 3px;\n  ", "\n  ", "\n  ", "\n"], ["\n  display: block;\n  clear: both;\n  border-radius: 3px;\n  ",
    "\n  ",
    "\n  ", "\n"])), function (props) { return "\n    padding: " + addPadding(props, props.theme.spacing) + ";\n  "; }, function (_a) {
    var theme = _a.theme, tiny = _a.tiny, flush = _a.flush, noBorder = _a.noBorder, rollover = _a.rollover, margin = _a.margin;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-color: ", ";\n    ", "\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    background-color: ", ";\n    ", "\n    ", "\n\n    ", "\n\n    ",
        "\n  "])), theme.colors.utility.white, !noBorder && "box-shadow: " + theme.shadows.low + ";", margin && "margin: " + margin + ";", rollover && theme.animations.hover, theme.mediaQueries.maxWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), !(tiny || flush) && "padding: " + theme.spacing.two + ";"));
}, spacingCss);
var templateObject_1, templateObject_2, templateObject_3;
